import { WorkspaceInvitationComponent } from "../../workspace/WorkspaceInvitationComponent";
import { ModalDefinitionModel, ModalSize } from "../ModalComponent";

export const WorkspaceInvitationHandler = () => {
    return {
        modalSize: ModalSize.Small,
        modalContent: <WorkspaceInvitationComponent />
    } as ModalDefinitionModel;
}